<style lang="less">
.evaluating{
	padding: 24px;
	.title{
		padding-bottom: 24px;
		.index{
			color: #F12528;
		}
	}
	.answers{
		.item{
			min-height: 48px;
			margin-bottom: 12px;
			border: 1px solid rgba(0,0,0,0.15);;
			border-radius: 5px;
			box-sizing: border-box;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			text-align: left;
			h3{
				font-size: 14px;
				padding: 8px 12px;
				font-weight: 400;
			}
			&.active, &:active{
				background: #fff7f7;
				color: #dc2a2a;
				border-color: #dc2a2a;
			}
		}
	}
	.tips{
		height: 43px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		padding: 0 8px;
		font-size: 12px;
		color: #d33a2a;
	}
	.ejump{
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 48px;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
		background: #f00;
		z-index: 999;
		color: #fff;
		font-size: 16px;
		font-weight: 700;
	}
}
</style>

<template>
	<!-- Main evaluating -->
	<section class="evaluating">
		<div class="title">
			<span class="index">{{index + 1}}</span>
			<span>/</span>
			<span>{{list.length}}</span>
			<span>{{list[index] && list[index].title}}</span>
		</div>
		<div class="answers" v-if="list[index]">
			<template v-for="(item, n) in list[index].answers">
				<div :class="curIndex === n ? 'active item' : 'item'" @click="ans(n)"  v-bind:key="'se_' + n">
					<h3>{{item}}</h3>
				</div>
			</template>
		</div>
		<div class="tips">{{tips}}</div>
		<div class="ejump" v-if="index == 0" @click="eva">跳过，我是稳健型</div>
		<footbtn btn-txt="提交" :is-on="isActive" @click.native="next"></footbtn>
	</section>
</template>

<script>
	/*
		global track
	*/
	import android from '@flyme/jr/js/android.js';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				result: {
					// index_0: '',
					// index_1: '',
					// index_2: '',
					// index_3: ''
				},
				index: 0,
				list: [],
				curIndex: '',
				menuShow: false,
				tips: ''
			};
		},
		computed: {
			isActive: function() {
				var check = true;
				for( var i in this.result ) {
					if (this.result[i] === "") {
						check = false;
						break;
					}
				}
				return check;
			}
		},
		components: {
			footbtn
		},
		mounted: function () {
			android('setTitle', {
				title: "风险等级测评"
			});
			this.getList();
		},
		beforeDestroy: function () {
			this.removMenu();
		},
		methods: {
			initMenu: function () {
				let _this = this;
				android('addMenuItem', {
					key: 'pre',
					text: '上一题',
					enable: true
				}, function () {
					_this.pre();
				});

			},
			removMenu: function () {
				android('removeAllMenuItem');
			},
			getList: function () {
				let _this = this;
				axios.post(apis.risk_grade_questions_list, {}).then(function(d) {
					console.log('risk_grade_questions_list', d);
					_this.list = d.value.questions_list_infos;

					var rest = {};
					for (var i = d.value.questions_list_infos.length - 1; i >= 0; i--) {
						rest['index_' + i] = '';

					}
					_this.result = Object.assign({}, _this.result, rest);
				});
			},
			ans: function (n) {
				this.result['index_' + this.index] = n;
				if (this.index < this.list.length-1) {
					this.index ++;
				}
				if (!this.menuShow) {
					this.initMenu();
					this.menuShow = true;
				}
			},
			pre: function () {
				this.result['index_' + this.index] = '';
				if (this.index > 0) {
					this.index --;
				}
				if (this.index === 0) {
					this.removMenu();
					this.menuShow = false;
				}
			},
			next: function () {
				let _this = this;

				if (!this.isActive) {
					return;
				}

				var ans = [];
				Object.keys(this.result).forEach(function (key) {
					ans.push(JSON.stringify({
						'question': parseInt(key.substr(6)) + 1,
						'answer': parseInt(_this.result[key]) + 1
					}));
				});

				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.risk_grade_evaluate, {'answer_info': '[' + ans.join(',') + ']'}).then(function(d) {
					android('hideLoadingDialog');
					console.log('risk_grade_evaluate', d);
					if (d.value && d.value.result) {
						_this.$router.replace({path: '/evaluating/result'});
					}else {
						_this.tips = d.message;
					}
				});
			},
			eva: function () {
				let _this = this;

				android('showLoadingDialog', {
					mes: '正在加载'
				});

				axios.post(apis.risk_grade_evaluate, {
					type: 2
				}).then(function(d) {
					console.log('risk_grade_evaluate', d);
					android('hideLoadingDialog');
					if (d.value.result) {
						track('event_ecash_evaluat');
						_this.$router.replace({path: '/evaluating/result'});
					}
				});
			},
		},
		watch: {
			result: {
				handler: function () {
					this.curIndex = this.result['index_' + this.index];
				},
				deep: true
			},
			index: function () {
				this.curIndex = this.result['index_' + this.index];
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Evaluating.vue